const c = {
  name: "Cloud",
  dimensions: { width: 40, height: 30 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 30" style="enable-background:new 0 0 40 30;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M30,30H7.5c-2.5,0-4.8-1.2-6.2-3.2c-1.4-2.1-1.7-4.7-0.8-7.1c0.9-2.4,2.9-4,5.4-4.5c-0.8-1.4-1.1-2.9-0.9-4.5
			c0.4-3.3,3-6,6.3-6.5c1.8-0.3,3.5,0.1,5,0.9c1.8-3.1,5-5,8.7-5c5.5,0,10,4.5,10,10c0,0.4,0,0.9-0.1,1.3C38,13,40,16.4,40,20
			C40,25.5,35.5,30,30,30L30,30z M7.4,17c-2.3,0-4.3,1.3-5,3.4c-0.7,1.8-0.5,3.8,0.6,5.3C4,27.1,5.7,28,7.5,28H30c4.4,0,8-3.6,8-8
			c0-3.1-1.8-5.9-4.6-7.2l-0.7-0.3l0.1-0.8c0.1-0.6,0.2-1.1,0.2-1.7c0-4.4-3.6-8-8-8c-3.2,0-6.1,1.9-7.4,4.9l-0.5,1.3l-1-0.9
			c-1.2-1-2.8-1.5-4.4-1.2C9.2,6.5,7.3,8.5,7,10.8c-0.2,1.7,0.3,3.2,1.5,4.4L9,15.9L8.2,17l-0.6,0C7.6,17,7.5,17,7.4,17L7.4,17z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Cloud
};
